import styled from 'styled-components';

export const Wrapper = styled.div` 
  display: flex;
  flex-direction: column;
  min-height: 73px;
  height: 100%;
  width: 100%;
  ${({ disabled }) => disabled && 'opacity: 0.5'};
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  flex: 0 0 14px;
  margin-bottom: 5px;
  letter-spacing: 0.09px;
  user-select: none;
  text-transform: capitalize;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: ${({ disabled, required, isEmpty }) => (!disabled && required && isEmpty ? '#EA3158' : '#AFB1BC')};
`;
Title.displayName = 'Title';

export const ErrorMessage = styled.div`
  flex: 0 0 12px;
  margin-top: 4px;
  user-select: none;
  text-transform: capitalize;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 10.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: #ea3158;
`;
ErrorMessage.displayName = 'ErrorMessage';

export const CustomInput = styled.input`
  flex: 1 1 0;
  width: 100%;
  border-style: solid;
  border-color: #afb1bc;
  border-width: 0px 0px 1px 0px;
  border-color: ${({
    disabled, error, required, isEmpty
  }) => ((error || (!disabled && required && isEmpty)) ? '#EA3158' : 'transparent')};
  padding: 0px 40px 0px 15px;
  font-size: 14.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.11px;
  color: #1c2243;
  background-color: ${({ isEmpty, theme }) => (isEmpty ? `${theme.textfield.background}` : theme.textfield.focus)}; 
  &::placeholder {
    color: ${({ theme }) => theme.text.placeholder};
    font-size: 13.5px;
    font-weight: 300;
  }

  &:focus{
      background-color: ${({ theme }) => theme.textfield.focus};         

      &::placeholder {
          color: transparent;
      }
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  /* Firefox */
  &[type=number] {
  -moz-appearance: textfield;
  }
`;
CustomInput.displayName = 'CustomInput';
